import { render, staticRenderFns } from "./UiGameInfo.vue?vue&type=template&id=164e1fb6&scoped=true&"
import script from "./UiGameInfo.vue?vue&type=script&lang=js&"
export * from "./UiGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./UiGameInfo.vue?vue&type=style&index=0&id=164e1fb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e1fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164e1fb6')) {
      api.createRecord('164e1fb6', component.options)
    } else {
      api.reload('164e1fb6', component.options)
    }
    module.hot.accept("./UiGameInfo.vue?vue&type=template&id=164e1fb6&scoped=true&", function () {
      api.rerender('164e1fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/UiGameInfo.vue"
export default component.exports